
import QuestionsAndAnswers from '@/components/catalog/product/QuestionsAndAnswers'
import BiddingAdviser from '@/components/catalog/product/BiddingAdviser'
import utils from '@/components/tools/utils'

export default {
  components: {
    QuestionsAndAnswers,
    BiddingAdviser
  },
  props: {
    exec: {
      type: String,
      default: undefined
    }
  },
  data: () => {
    return {
      currentPrice: 39600,
      targetPrice: 47000
    }
  },
  computed: {
    biddingAdviserSliderData () {
      const prices = []

      let price = this.currentPrice
      while (price <= this.targetPrice * 1.1) {
        prices.push(
          {
            id: price.toString(),
            name: this.formatCurrency(price)
          }
        )
        price += 100
      }

      return prices
    }

  },
  methods: {
    formatCurrency (value) {
      return utils.formatCurrency(value)
    }
  }
}
